// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"MuiTooltip_tooltip__CK0-m","arrow":"MuiTooltip_arrow__3fnLf"};